<greco-coupons-table [communityId]="communityId"></greco-coupons-table>
